/**
 * Labstep
 *
 * @desc Lightbox. Wrapper around https://yet-another-react-lightbox.com/documentation
 */

import { useToggle } from 'labstep-web/hooks/toggle';
import type React from 'react';
import ReactLightbox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

import type { ILightboxProps } from './types';

export const Lightbox: React.FC<ILightboxProps> = ({
  children,
  images,
  ...rest
}) => {
  const [toggled, toggle] = useToggle();

  return (
    <>
      {children({ toggle })}

      {toggled && (
        <ReactLightbox
          slides={images.map((image) => ({
            src: image.src,
            title: image.caption,
          }))}
          render={{
            buttonPrev: () => false,
            buttonNext: () => false,
          }}
          close={toggle}
          className={rest.wrapperClassName}
          plugins={[Captions, Fullscreen, Thumbnails, Zoom]}
        />
      )}
    </>
  );
};
